module.exports = __webpack_public_path__ + "static/media/twitch.8cfd2009.svg";